import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Layer = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox={`0 0 ${size} ${size}`}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7961 6.0304L4.04882 10.2254C3.10483 10.8123 3.10483 12.1862 4.04882 12.7732L5.54742 13.7049L3.78481 14.8008C2.52616 15.5833 2.52616 17.4152 3.78481 18.1977L10.5321 22.3928C11.7083 23.1241 13.2052 23.093 14.35 22.3134L20.4606 18.1524C21.6264 17.3586 21.6264 15.64 20.4606 14.8461L18.7728 13.6968L20.1792 12.7391C21.0535 12.1438 21.0535 10.8548 20.1792 10.2595L14.0686 6.09845C13.0873 5.43023 11.8043 5.40355 10.7961 6.0304ZM17.8844 14.3017L14.0686 16.9001C13.0873 17.5684 11.8043 17.595 10.7961 16.9682L6.49438 14.2937L4.31281 15.65C3.68349 16.0413 3.68349 16.9572 4.31281 17.3485L11.0601 21.5435C11.9003 22.0659 12.9695 22.0437 13.7872 21.4868L19.8978 17.3258C20.4806 16.9289 20.4806 16.0696 19.8978 15.6727L17.8844 14.3017Z"
        fill={color}
      />
    </svg>
  )
})

export default Layer
